<template>
  <div>
    <table class="featureTable">
      <thead>
      <th>
        Feature
      </th>
      <th>
        Specification
      </th>
      <th>
        Info and upgrade options
      </th>
      </thead>
      <tbody>
      <tr>
        <td>
          Printing capabilities
        </td>
        <td>
          {{ model.printing_capabilities }}
        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="PRINTING CAPABILITIES">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Programmable jobs
        </td>
        <td>
          {{ model.programmable_jobs }}
        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="PROGRAMMABLE JOBS">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Ink yield
        </td>
        <td>
          {{ model.ink_yield }} impressions per ink cartridge
        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="INK YIELD">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Cost per impression
        </td>
        <td>
          <span v-html="$root.mnwp(model.cost_per_impression)"></span>
        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="COST PER IMPRESSION">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Logo return address capacity
        </td>
        <td>
          {{ model.return_address_capacity }}
        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="LOGO RETURN ADDRESS CAPACITY">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Interface type
        </td>
        <td>
          {{ model.interface_type }}
        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="INTERFACE TYPE">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Mail feeder
        </td>
        <td>
          {{ model.mail_feeder }}
        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="MAIL FEEDER">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Label dispenser
        </td>
        <td>
          {{ model.label_dispenser }}
        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="LABEL DISPENSER">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Web based reporting
        </td>
        <td>
          <img src="./../../../../static/styles/mailkit/img/tick.png"
               v-if="model.web_based_reporting === 'yes'"/>
          <img src="./../../../../static/styles/mailkit/img/cross.png" v-else/>

        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="WEB BASED REPORTING">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Dimension
        </td>
        <td>
          {{ model.dimensions }}
        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="DIMENSIONS">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Mail mark compliant
        </td>
        <td>
          <img src="./../../../../static/styles/mailkit/img/tick.png"
               v-if="model.mail_mark_compliant === 'yes'"/>
          <img src="./../../../../static/styles/mailkit/img/cross.png" v-else/>
        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="MAIL MARK COMPLIANT">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Installation and training
        </td>
        <td>
          <img src="./../../../../static/styles/mailkit/img/tick.png"
               v-if="model.engineer_installation_training === 'Included' || additionalOptions.engineer_installation_training === 'add'"/>
          <img src="./../../../../static/styles/mailkit/img/cross.png"
               v-if="additionalOptions.engineer_installation_training !== 'add' && (additionalOptions.engineer_installation_training === false || model.engineer_installation_training === null || model.engineer_installation_training === 'Not Included (Available at additional cost)')"/>
          <span v-if="additionalOptions.engineer_installation_training === null && model.engineer_installation_training === 'Not Included (Available at additional cost)'">
                  <br>
                  Available at additional cost
                </span>
        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="INSTALLATION AND TRAINING">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Scale capacity
        </td>
        <td>
          {{ formatScale(model, additionalOptions) }} KG
        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="SCALE CAPACITY">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Custom Logo/Return Address Included with New Machine
        </td>
        <td>
                <span v-if="additionalOptions.logo_and_return_address === 'add' || (model.return_address_included_with_machine === 'Included' && additionalOptions.logo_and_return_address === null)">
                  <img src="./../../../../static/styles/mailkit/img/tick.png">
                </span>
          <span v-else>
                  <img src="./../../../../static/styles/mailkit/img/cross.png"/>
                  <br>
                  <span v-if="additionalOptions.logo_and_return_address === null">Available at additional cost</span>
                </span>
        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;"
               data-ft="CUSTOM LOGO/RETURN ADDRESS INCLUDED WITH NEW MACHINE">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Business mail advanced
        </td>
        <td>
          <span v-if="additionalOptions.business_mail_advanced === 'add'">
            <img src="./../../../../static/styles/mailkit/img/tick.png">
          </span>
          <span v-if="(!model.business_mail_advanced || !model.business_mail_advanced.includes('included')) || additionalOptions.business_mail_advanced === false">
            <img src="./../../../../static/styles/mailkit/img/cross.png"/>
          </span>
          <span v-if="(model.business_mail_advanced && model.business_mail_advanced.includes('included')) && additionalOptions.business_mail_advanced === null">
            <img src="./../../../../static/styles/mailkit/img/cross.png"/>
            <br>
            <span>Available at additional cost</span>
          </span>
        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="BUSINESS MAIL ADVANCED">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Connectivity kit options
        </td>
        <td>
                <span v-if="additionalOptions.connectivity === null">
                  {{ model.connectivity }}
                </span>
          <span style="text-transform: uppercase" v-if="additionalOptions.connectivity !== null">
                  {{ additionalOptions.connectivity }}
                </span>
        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="CONNECTIVITY KIT OPTIONS">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Inbound courier parcel tracing
        </td>
        <td>
          <img src="./../../../../static/styles/mailkit/img/tick.png"
               v-if="model.integrated_internal_mail_tracking_app.includes('Included') && (additionalOptions.inbound_courier_parcel_tracking_cost === null || additionalOptions.inbound_courier_parcel_tracking_cost === 'add')"/>
          <img src="./../../../../static/styles/mailkit/img/cross.png" v-else/>
          <br>
          {{ model.integrated_internal_mail_tracking_app }}
        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="INBOUND COURIER PARCEL TRACING">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Outbound shipping application
        </td>
        <td>
                <span v-if="additionalOptions.outbound_shipping_application === null">
                  {{ model.shipping_application }}
                  <span v-if="model.shipping_application === 'Yes Single User Included (Optional Kit available includes 30kg Scale and Shipping Label Printer)'">
                   Available at additional cost
                  </span>
                </span>
          <span v-else>
                  <span v-if="additionalOptions.outbound_shipping_application === 'add'">
                    <img src="./../../../../static/styles/mailkit/img/tick.png"/>
                  </span>
                  <span v-if="additionalOptions.outbound_shipping_application === false">
                    <img src="./../../../../static/styles/mailkit/img/cross.png"/>
                  </span>
                </span>
        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="OUTBOUND SHIPPING APPLICATION">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Departmental accounting
        </td>
        <td>
          {{ getModelDepAccounting(model) }}
        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="DEPARTMENTAL ACCOUNTING">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Differential weighting
        </td>
        <td>
          <img src="./../../../../static/styles/mailkit/img/tick.png" v-if="additionalOptions.differential_weighting === 'add'"/>
          <img src="./../../../../static/styles/mailkit/img/cross.png" v-if="!model.differential_weighting || model.differential_weighting === 'No' || additionalOptions.differential_weighting === false"/>
          <span v-if="(model.differential_weighting === 'Yes' || model.differential_weighting === 'Optional') && additionalOptions.differential_weighting === null">
                  Available at additional cost
                </span>
        </td>
        <td>
          <a class="underline infoToggle">More information</a>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="DIFFERENTIAL WEIGHING">
          </div>
        </td>
      </tr>
      <tr style="background: #f4f4f4;border-top:0">
        <td>
          Service / maintenance offering
        </td>
        <td>
                <span v-if="!service_upgrade && !new_costs.postage_recredit_costs_updated_to_total_care">
                  {{ model.service_name }}
                </span>
          <span v-if="service_upgrade == 'swapit'">
                  swapit+
                </span>
          <span v-if="service_upgrade == 'total_care' || new_costs.postage_recredit_costs_updated_to_total_care">
                  total care
                </span>
        </td>
        <td>
        </td>
      </tr>
      <tr class="noSeparator">
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="SERVICE / MAINTENANCE OFFERING">
          </div>
        </td>
      </tr>
      <tr style="background: #f4f4f4;border-top:0" class="noSeparator">
        <td>
          First step
        </td>
        <td>
          {{ model.first_step }}
        </td>
        <td>
        </td>
      </tr>
      <tr class="noSeparator">
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="FIRST STEP">
          </div>
        </td>
      </tr>
      <tr style="background: #f4f4f4;border-top:0" class="noSeparator">
        <td>
          Second step
        </td>
        <td>
          {{ model.second_step }}
        </td>
        <td>
        </td>
      </tr>
      <tr class="noSeparator">
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="SECOND STEP">
          </div>
        </td>
      </tr>
      <tr style="background: #f4f4f4;border-top:0">
        <td>
          {{ service_upgrade || new_costs.postage_recredit_costs_updated_to_total_care ? 'ENHANCED' : null }} Third step
        </td>
        <td>
          {{ service_upgrade || new_costs.postage_recredit_costs_updated_to_total_care ? model.enhanced_third_step : model.third_step }}
        </td>
        <td>
        </td>
      </tr>
      <tr class="noSeparator">
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="THIRD STEP">
          </div>
        </td>
      </tr>
      <tr style="background: #f4f4f4;border-top:0" class="noSeparator">
        <td>
          {{ service_upgrade || new_costs.postage_recredit_costs_updated_to_total_care ? 'ENHANCED' : null }} Targeted service level
        </td>
        <td>
          {{ service_upgrade || new_costs.postage_recredit_costs_updated_to_total_care ? model.sla_enhanced : model.sla_standard }}
        </td>
        <td>
        </td>
      </tr>
      <tr class="noSeparator">
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="TARGETED SERVICE LEVEL">
          </div>
        </td>
      </tr>
      <tr style="background: #f4f4f4;border-top:0" class="noSeparator">
        <td>
          All parts
        </td>
        <td>
          <img src="./../../../../static/styles/mailkit/img/cross.png"
               v-if="model.all_parts === null"/>
          <span v-else>
                   <img src="./../../../../static/styles/mailkit/img/tick.png"/> Yes
                </span>
        </td>
        <td>
        </td>
      </tr>
      <tr class="noSeparator">
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="ALL PARTS">
          </div>
        </td>
      </tr>
      <tr>
        <td>
          All labour
        </td>
        <td>
          <img src="./../../../../static/styles/mailkit/img/cross.png"
               v-if="model.all_labour === null"/>
          <span v-else>
                   <img src="./../../../../static/styles/mailkit/img/tick.png"/> Yes
                </span>
        </td>
        <td>
        </td>
      </tr>
      <tr class="noSeparator">
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="ALL LABOUR">
          </div>
        </td>
      </tr>
      <tr style="background: #f4f4f4;border-top:0">
        <td>
          Wear & tear
        </td>
        <td>
          <img src="./../../../../static/styles/mailkit/img/cross.png"
               v-if="model.wear_and_tear === null"/>
          <span v-else>
                   <img src="./../../../../static/styles/mailkit/img/tick.png"/> Yes - Excluding Consumable Parts
                </span>

        </td>
        <td>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="WEAR & TEAR">
          </div>
        </td>
      </tr>
      <tr style="background: white;">
        <td>
          Royal mail rate updates
        </td>
        <td>
          {{ model.tariff_rate_updates_included_per_annum }} Per annum
        </td>
        <td>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="ROYAL MAIL RATE UPDATES">
          </div>
        </td>
      </tr>
      <tr style="background: #f4f4f4;" class="separator">
        <td>
          Postage account type
        </td>
        <td>
                <span v-if="additionalOptions.postage_payment" style="text-transform: uppercase">
                  {{ additionalOptions.postage_payment }}
                </span>
          <!--<span v-else>-->
          <!--{{ model.manufacturer_id == 3 || model.manufacturer_id == 2 ? 'Arvanced or arrears' : 'ADVANCED' }}-->
          <!--</span>-->
        </td>
        <td>
        </td>
      </tr>
      <tr class="noSeparator">
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="POSTAGE ACCOUNT TYPE">
          </div>
        </td>
      </tr>


      <tr style="background: #f4f4f4;border-top:0" v-if="additionalOptions.postage_payment === 'advanced'">
        <td>
          Free resets
        </td>
        <td>
                <span style="text-transform: uppercase">
                  <!-- Commented out by Duncan's request from 16.08.2019 at 7:00PM GMT+2 {{ model.postage_credit_account_free_resets || 0 }} -->
                  {{ model.postage_deposit_account || 0 }}
                </span>
        </td>
        <td>
        </td>
      </tr>
      <tr v-if="additionalOptions.postage_payment === 'advanced'">
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="POSTAGE ACCOUNT TYPE"></div>
        </td>
      </tr>


      <tr style="background: #f4f4f4;border-top:0" v-if="additionalOptions.postage_payment === 'advanced'">
        <td>
          Cost per additional reset
        </td>
        <td>
                <span style="text-transform: uppercase">
                  {{ model.postage_credit_account_per_future_resets || 0 }}
                </span>
        </td>
        <td>
        </td>
      </tr>
      <tr v-if="additionalOptions.postage_payment === 'advanced'">
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="POSTAGE ACCOUNT TYPE"></div>
        </td>
      </tr>


      <tr style="background: #f4f4f4;border-top:0" v-if="additionalOptions.postage_payment === 'arrears'">
        <td>
          Monthly Top Up Cost
        </td>
        <td>
                <span style="text-transform: uppercase">
                  &pound;{{ (model.monthly_top_up_option_1_transaction_fee || 0) * 12 }}
                </span>
        </td>
        <td>
        </td>
      </tr>
      <tr v-if="additionalOptions.postage_payment === 'arrears'">
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="POSTAGE ACCOUNT TYPE"></div>
        </td>
      </tr>

      <tr style="background: #f4f4f4;border-top:0" v-if="additionalOptions.postage_payment === 'arrears'">
        <td>
          Cost per additional postage top up
        </td>
        <td>
                <span style="text-transform: uppercase">
                  <span>&pound;{{ new_costs.postage_recredit_costs }}</span>
                </span>
        </td>
        <td>
        </td>
      </tr>
      <tr v-if="additionalOptions.postage_payment === 'arrears'">
        <td colspan="3" class="nopadding">
          <div class="infoContent" style="display:none;" data-ft="POSTAGE ACCOUNT TYPE"></div>
        </td>
      </tr>

      </tbody>
    </table>
  </div>
</template>
<script>
  //./../../../../../
  export default {
    name: 'features',
    props: ['order'],
    created() {
      this.additionalOptions = this.order.additional_options
    },
    mounted() {
/*      $('.infoToggle').click(function () {
        let $el = $(this).parent().parent().next().find('.infoContent')
        if(!($el.hasClass('active')))
          $el.addClass('active').slideDown(300);
        else
          $el.removeClass('active').slideUp(300)
      })*/
      this.service_upgrade = this.order.additional_options.service_upgrade || this.order.quote.postage_spend_custom > 7500;
    },
    data() {
      return {
        additionalOptions: {},
        model: this.order.costs.printer,
        new_costs: this.order.costs,
        service_upgrade: null,
      }
    },
    methods: {
      formatScale(model, additionalOptions) {

        let capacity = this.additionalOptions.packets_capacity.split('_')
        let cap1 = capacity[0]
        let cap2 = capacity[1] || null

        if (model.scale_capacity >= cap1) {
          return model.scale_capacity
        }

        for (let i = 1; i < 5; i++) {
          if (model['scale_option_' + i] >= cap1) {
            return model['scale_option_' + i]
          }
        }

        return model.scale_capacity


      },
      getModelDepAccounting(model) {

        if (model.departmental_accounting >= this.additionalOptions.accounts_amount) {
          return model.departmental_accounting
        }

        for (let i = 1; i < 5; i++) {
          if (model['accounting_option_' + i] >= this.additionalOptions.accounts_amount) {
            return model['accounting_option_' + i]
          }
        }

        return model.departmental_accounting
      }
    }
  }
</script>
<style>
  td {
    text-align: center;
  }

  .infoContent {
    text-align: center;
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/Order/specification/Features.vue